module.exports = __webpack_public_path__ + "static/media/lock-mailer-render.dcae3a0c.png";